<template>
  <div v-if="isOtp.active">
    <span class="title">대기확정코드:</span>
    <strong class="otp">{{ isOtp.notice }}</strong>
  </div>
  <div v-else>{{ isOtp.notice }}</div>
</template>

<script>
export default {
  props: ['otpNumber', 'isCWType', 'useWaitingConfirmCode'],
  name: 'waitingTeams',
  components: {
  },
  data () {
    return {

    }
  },
  computed: {
    isOtp () {
      let result = ''
      if (!this.isCWType) result = '현장 대기접수만 가능한 매장입니다.'
      if (this.isCWType && !this.useWaitingConfirmCode) result = '대기확정코드 없이 원격줄서기가 가능한 매장입니다.'
      if (this.isCWType && this.useWaitingConfirmCode) result = this.otpNumber
      return { active: this.isCWType && this.useWaitingConfirmCode, notice: result }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";
.title {
  display: inline-block;
}

.otp {
  color: $white;
  padding: 0 0 0 8px;
  font-size: 27px;
  font-weight: $bold;

  @include fhd_combo {
    padding: 0 0 0 12px;
    font-size: 40px;
  }

  @include qhd_combo {
    padding: 0 0 0 16px;
    font-size: 53px;
  }
}
</style>
